import { Skeleton } from "@/components/skeleton";

const SKELETON_ROWS = 10;

const TABLE_GRID =
  "grid grid-cols-[minmax(110px,130fr)_minmax(120px,139fr)_minmax(240px,438fr)_minmax(230px,248fr)_minmax(100px,161fr)_minmax(100px,132fr)]";

const COLUMN_LABELS = [
  "Total",
  "Date",
  "Description",
  "Invoice ID",
  "Status",
  "Action",
];

export function InvoicesSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading invoices">
      <div className="hidden pt-xl md:block">
        <div
          className={`${TABLE_GRID} h-11 items-center border-b border-b-border-secondary bg-bg-secondary`}
        >
          {COLUMN_LABELS.map((label) => (
            <span
              className="truncate px-3xl text-xs font-semibold text-text-tertiary"
              key={label}
            >
              {label}
            </span>
          ))}
        </div>

        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div
            className={`${TABLE_GRID} items-center border-b border-b-border-secondary`}
            key={i}
          >
            <div className="flex h-5 items-center px-3xl py-xl box-content">
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="px-3xl">
              <Skeleton className="h-3.5 w-24" />
            </div>
            <div className="px-3xl">
              <Skeleton className="h-3.5 w-3/4" />
            </div>
            <div className="px-3xl">
              <Skeleton className="h-3.5 w-48" />
            </div>
            <div className="px-3xl">
              <Skeleton className="h-[22px] w-14 rounded-full" />
            </div>
            <div className="flex items-center gap-xs px-3xl">
              <Skeleton className="size-8 rounded-md" />
              <Skeleton className="size-8 rounded-md" />
            </div>
          </div>
        ))}
      </div>

      <div className="flex flex-col divide-y divide-border-secondary md:hidden">
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div className="flex items-center gap-md px-3xl py-xl" key={i}>
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="ml-auto h-[22px] w-14 rounded-full" />
            <Skeleton className="size-5" />
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-md border-t border-border-secondary px-3xl pt-xl pb-2xl md:justify-between md:pt-lg md:pb-xl">
        <Skeleton className="hidden h-10 w-[159px] rounded-md md:block" />
        <Skeleton className="h-9 w-72 rounded-md md:w-96" />
      </div>
    </div>
  );
}
